<script setup>
import { useDisplay } from 'vuetify';

const { mdAndDown } = useDisplay();
defineProps([
    'page',
    'isMobile',
    'title',
    'titleBadges',
    'show',
    'isSingle',
    'mode',
    'hideIcons',
    'saving',
    'saveButtonText',
    'hideNewAction',
    'hideRemoveAction',
    'hideEditAction',
    'hideSaveButton',
    'onlyView',
    'disableClose',
    'hasChanges'
]);
const emit = defineEmits([
    'save',
    'edit',
    'new',
    'remove',
    'close',
    'badgeClick'
]);

const handleBadgeClick = (badge, index) => {
    if (badge.action || badge.clickable !== false) {
        emit('badgeClick', { badge, index });
    }
};
</script>

<template>
    <div class="mb-6 w-100">
        <v-btn
            variant="tonal"
            icon
            dark
            @click="emit('close')"
            size="small"
            class="close-button"
            color="primary"
        >
            <v-icon size="large">mdi-arrow-left</v-icon>
        </v-btn>

        <v-row v-if="!isSingle">
            <v-col
                :cols="isMobile && 12"
                class="titleModal"
                :class="{ 'text-center py-0': isMobile }"
            >
                <a class="no-link" href="javascript:void(0);">{{ page }}</a>
                <div v-if="!isMobile">
                    {{ title }}
                    <span
                        v-if="hasChanges"
                        style="
                            display: inline-block;
                            width: 10px;
                            height: 10px;
                            border-radius: 50%;
                            background: red;
                            margin-left: 6px;
                            vertical-align: middle;
                        "
                    ></span>
                </div>
                <div v-if="isMobile">
                    <div>
                        {{ title }}

                        <span
                            v-if="hasChanges"
                            style="
                                display: inline-block;
                                width: 10px;
                                height: 10px;
                                border-radius: 50%;
                                background: red;
                                margin-left: 6px;
                                vertical-align: middle;
                            "
                        ></span>
                    </div>
                </div>
                <!-- Badges in separate line -->
                <div v-if="titleBadges && titleBadges.length > 0" class="mt-2">
                    <v-chip
                        v-for="(badge, index) in titleBadges"
                        :key="index"
                        :color="badge.color"
                        class="mr-1 mb-1"
                        :class="{
                            'cursor-pointer':
                                badge.action || badge.clickable !== false
                        }"
                        size="small"
                        @click="handleBadgeClick(badge, index)"
                    >
                        <v-icon
                            v-if="badge.icon"
                            :icon="badge.icon"
                            size="small"
                            :class="{ 'mr-1': badge.text }"
                        />
                        <span v-if="badge.text">{{ badge.text }}</span>
                    </v-chip>
                </div>
            </v-col>
            <v-col
                :cols="isMobile && 12"
                class="text-center pt-0"
                :class="{ 'py-0': isMobile }"
                v-if="!hideIcons"
            >
                <v-btn
                    v-if="!hideEditAction"
                    icon
                    :variant="mode === 'edit' ? 'outlined' : 'text'"
                    @click="emit('edit')"
                >
                    <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn
                    v-if="!hideNewAction"
                    icon
                    variant="text"
                    @click="emit('new')"
                    class="mx-3"
                >
                    <v-icon>mdi-sticker-plus-outline</v-icon>
                </v-btn>
                <v-btn
                    v-if="!hideRemoveAction"
                    icon
                    variant="text"
                    @click="emit('remove')"
                >
                    <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
            </v-col>
            <v-col
                :cols="isMobile && 12"
                class="text-right"
                :class="{ 'text-center py-0': isMobile }"
            >
                <v-btn
                    v-if="!onlyView && !hideSaveButton"
                    color="primary"
                    variant="tonal"
                    @click="emit('save')"
                    :loading="saving"
                    :disabled="mode === 'view'"
                    :class="{ 'mt-2': mdAndDown }"
                >
                    {{ saveButtonText ? saveButtonText : $t('Save') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col
                :cols="isMobile ? 12 : 6"
                class="titleModal"
                :class="{ 'text-center py-0': isMobile }"
            >
                <a class="no-link" href="javascript:void(0);">{{ page }}</a>
                <div v-if="!isMobile">
                    {{ title }}
                </div>
                <div v-if="isMobile">
                    <div>{{ title }}</div>
                </div>
                <!-- Badges in separate line -->
                <div v-if="titleBadges && titleBadges.length > 0" class="mt-2">
                    <v-chip
                        v-for="(badge, index) in titleBadges"
                        :key="index"
                        :color="badge.color"
                        class="mr-1 mb-1"
                        :class="{
                            'cursor-pointer':
                                badge.action || badge.clickable !== false
                        }"
                        size="small"
                        @click="handleBadgeClick(badge, index)"
                    >
                        <v-icon
                            v-if="badge.icon"
                            :icon="badge.icon"
                            size="small"
                            :class="{ 'mr-1': badge.text }"
                        />
                        <span v-if="badge.text">{{ badge.text }}</span>
                    </v-chip>
                </div>
            </v-col>
            <v-col
                :cols="isMobile && 4"
                class="text-right"
                :class="{ 'text-center py-0': isMobile }"
            >
                <v-btn
                    v-if="!onlyView && !hideSaveButton"
                    color="primary"
                    variant="tonal"
                    @click="emit('save')"
                    :loading="saving"
                    :disabled="mode === 'view'"
                    :class="{ 'mt-2': mdAndDown }"
                >
                    {{ saveButtonText ? saveButtonText : $t('Save') }}
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>
<style lang="scss" scoped>
@media only screen and (min-device-width: 320px) and (max-device-width: 800px) {
    .mb-6 {
        padding: 1.8rem 1.3rem;
        position: fixed;
        background-color: white;
        z-index: 5;
    }
}
@media only screen and (min-width: 800px) {
    .close-button {
        position: absolute;
        left: 15px;
        top: 15px;
    }
}

.cursor-pointer {
    cursor: pointer;
}
</style>
